export const GET_DEBIT_CREDIT_SETTINGS = 'GET_DEBIT_CREDIT_SETTINGS'
export const GET_DEBIT_CREDIT_SETTINGS_SUCCESS = 'GET_DEBIT_CREDIT_SETTINGS_SUCCESS'
export const GET_DEBIT_CREDIT_SETTINGS_FAILED = 'GET_DEBIT_CREDIT_SETTINGS_FAILED'

export const UPDATE_DEBIT_CREDIT_SETTINGS = 'UPDATE_DEBIT_CREDIT_SETTINGS'
export const UPDATE_DEBIT_CREDIT_SETTINGS_SUCCESS = 'UPDATE_DEBIT_CREDIT_SETTINGS_SUCCESS'
export const UPDATE_DEBIT_CREDIT_SETTINGS_FAILED = 'UPDATE_DEBIT_CREDIT_SETTINGS_FAILED'
